export const CONVERSATION_FEATURE_KEY = 'conversation';
